import { render, staticRenderFns } from "./FacebookLoginComponent.vue?vue&type=template&id=f98ff116&scoped=true"
import script from "./FacebookLoginComponent.vue?vue&type=script&lang=js"
export * from "./FacebookLoginComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f98ff116",
  null
  
)

export default component.exports